// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__vPEkF","logo__obj":"logo_logo__obj__zHMtL"};